import Dialog from '@/components/Dialog.vue'
import Pagenation from '@/components/Pagenation.vue'
import Keyboard from '@/components/Keyboard.vue'
import InputCustom from '@/components/InputCustom.vue'
import DialogKey from '@/components/DialogKey.vue'
import DialogTip from '@/components/DialogTip.vue'
import DialogError from '@/components/DialogError.vue'
import CartItemDetail from '@/components/CartItemDetail.vue'

const my_components = {
  install: function (Vue) {
    Vue.component('Dialog', Dialog)
    Vue.component('Pagenation', Pagenation)
    Vue.component('Keyboard', Keyboard)
    Vue.component('InputCustom', InputCustom)
    Vue.component('DialogKey', DialogKey)
    Vue.component('DialogTip', DialogTip)
    Vue.component('DialogError', DialogError)
    Vue.component('CartItemDetail', CartItemDetail)
  }
}

export default my_components;
